<template>
  <div>
    <form
      id="form1"
      method="post"
      action="https://sbcheckout.payfort.com/FortAPI/paymentPage"
      name="form1"
    >
      <input type="hidden" name="service_command" value="TOKENIZATION" />
      <input type="hidden" name="language" :value="language" />
      <input
        type="hidden"
        name="merchant_identifier"
        :value="merchantIdentifier"
      />
      <input type="hidden" name="access_code" :value="accessCode" />
      <input type="hidden" name="signature" :value="signature" />
      <input type="hidden" name="return_url" :value="returnUrl" />
      <input
        type="hidden"
        name="merchant_reference"
        :value="merchantReference"
      />
      <input type="hidden" name="card_number" :value="cardNumber" />
      <input
        type="hidden"
        name="expiry_date"
        :value="expiryYear + expiryMonth"
      />
      <input
        type="hidden"
        name="card_security_code"
        :value="cardSecurityCode"
      />
      <input
        type="hidden"
        name="card_holder_name"
        :value="cardFirstName + ' ' + cardLastName"
      />
      <input
        v-if="remember"
        type="hidden"
        name="remember_me"
        :value="remember ? 'YES' : null"
      />
      <input id="submit2" class="submit-hiden" type="submit" value="" name="" />
    </form>
    <div class="card-payfort">
      <div class="card-logo-payment-wrapper">
        <img src="@/assets/images/mada-dark-nobg.png" width="74px" />
        <img
          src="@/assets/images/icons/MC_color.svg"
          width="35px"
          style="padding-top: 4px; padding-bottom: 4px"
        />
        <img src="@/assets/images/icons/Visa_color.svg" width="60px" />
      </div>
      <div class="form-group mt-4">
        <input
          id="card_number"
          v-model="cardNumber"
          type="text"
          name="card_number"
          :class="{ 'error-input': cardError, 'font-Alexsandria': isRTL }"
          class="input-form"
          :placeholder="$t('_web_pay_fort_card-number', 'Card Number')"
          @input="handleInput"
        />
      </div>
      <div class="form-group">
        <div class="cvv-date">
          <div>
            <div class="expDate">
              <input
                id="expiry_month"
                ref="expiryMonth"
                v-model="expiryMonth"
                type="text"
                class="input-form exp-date-field month-class"
                style="padding-left: 10px"
                :class="{
                  'error-input-month': dateError,
                  'font-Alexsandria': isRTL,
                }"
                :placeholder="$t('_web_pay_fort_mm', 'MM')"
                maxlength="2"
                name="expiry_date"
                @input="handleInput"
              />
              <span
                class="exp-date-field-devider"
                :class="{
                  'error-input-devider': dateError,
                  'font-Alexsandria': isRTL,
                }"
                style="display: flex"
                >/</span
              >
              <input
                id="expiry_year"
                ref="expiryYear"
                v-model="expiryYear"
                type="text"
                class="input-form exp-date-field year-class"
                :class="{
                  'error-input-year': dateError,
                  'font-Alexsandria': isRTL,
                }"
                :placeholder="$t('_web_pay_fort_yy', 'YY')"
                name="expiry_date"
                maxlength="2"
                @input="handleInput"
              />
            </div>
          </div>
          <div class="cvv-input-field">
            <input
              id="card_security_code"
              v-model="cardSecurityCode"
              type="text"
              name="card_security_code"
              :class="{ 'error-input': cvvError, 'font-Alexsandria': isRTL }"
              :placeholder="$t('_web_pay_fort_cvv', 'CVV')"
              class="input-form input-cvv"
              maxlength="4"
              @input="handleInput"
            />
          </div>
        </div>
      </div>
      <div class="name-container">
        <div class="name-input">
          <input
            id="card_holder_name"
            v-model="cardFirstName"
            class="input-form card-holder-name"
            type="text"
            :placeholder="
              $t('_web_pay_fort_card_holder_name', 'Card holder name')
            "
            :class="{
              'error-input': FirstNameError,
              'font-Alexsandria': isRTL,
            }"
            name="card_holder_name"
            required="true"
          />
        </div>
      </div>

      <div class="remember-me">
        <input
          id="rememberMe"
          v-model="remember"
          type="checkbox"
          name="remember_me"
        />
        <label class="payfort-save-card" for="rememberMe">{{
          $t('_web_pay_fort_save-my-card', 'Save my card for next purchase')
        }}</label>
      </div>
      <p v-if="errorMessage && errors.length === 1" class="error-message">
        {{ errorMessage }}
      </p>
      <p v-if="errors.length > 1" class="error-message">
        {{ $t(
          '_web_pay_fort_please-required',
          'Please fill all required fields'
        ), }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'PayFort',

  props: {
    subscription: {
      type: String,
      default: '',
    },
    coupon: {
      type: String,
      default: '',
    },
    isShop: {
      type: Boolean,
      default: false,
    },
    order: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      serviceCommand: 'TOKENIZATION',
      language: 'en',
      merchantIdentifier: 'a2669d8e',
      accessCode: 'R2XXiG8IsM5v7oFWEkpv',
      signature: '',
      returnUrl: '',
      merchantReference: '',
      cardNumber: '',
      // '4005550000000001',
      expiryMonth: '',
      expiryYear: '',
      cardSecurityCode: '',
      cardHolderName: '',
      cardFirstName: '',
      cardLastName: '',
      remember: null,
      cardError: '',
      cvvError: '',
      dateError: '',
      cardType: '',
      FirstNameError: '',
      LastNameError: '',
      cardValidity: null,
      cvvValidity: null,
      expValidity: null,
      apsPaymentErrors: {
        invalid_card: this.$t('_web_pay_fort_invalid-card', 'Invalid Card'),
        invalid_card_length: this.$t(
          '_web_pay_fort_invalid-card-length',
          'Invalid Card Length'
        ),
        card_empty: this.$t(
          '_web_pay_fort_card-number-empty',
          'Card Number Empty'
        ),
        invalid_card_holder_name: this.$t(
          '_web_pay_fort_invalid-card-holder',
          'Invalid Card Holder Name'
        ),
        invalid_card_cvv: this.$t(
          '_web_pay_fort_Invalid-CVV',
          'Invalid Card CVV'
        ),
        empty_card_cvv: this.$t('_web_pay_fort_empty-CVV', 'CVV is required'),
        invalid_expiry_date: this.$t(
          '_web_pay_fort_Invalid-expiry-date',
          'Invalid Expiry Date'
        ),
        invalid_expiry_year: this.$t(
          '_web_pay_fort_Invalid-year',
          'Invalid Expiry Year. Expected as YY'
        ),
        invalid_expiry_month: this.$t(
          '_web_pay_fort_Invalid-month',
          'Invalid Expiry Month. Expected as MM'
        ),
        empty_expiry_date: this.$t(
          '_web_pay_fort_empty-date',
          'Expiry date is required'
        ),
      },
    };
  },
  computed: {
    ...mapGetters(['isRTL']),
    expiryDate() {
      return this.expiryYear + this.expiryMonth;
    },
    errors() {
      return [
        this.dateError,
        this.cardError,
        this.cvvError,
        this.FirstNameError,
        // this.LastNameError,
      ].filter(item => item !== '');
    },
    bins() {
      return {
        mada:
          '446404|440795|440647|421141|474491|588845|968208|457997|457865|468540|468541|468542|468543|417633|446393|636120|968201|410621|409201|403024|458456|462220|968205|455708|484783|588848|455036|968203|486094|486095|486096|504300|440533|489318|489319|445564|968211|410685|406996|432328|428671|428672|428673|968206|446672|543357|434107|407197|407395|42689700|412565|431361|604906|521076|588850|968202|529415|535825|543085|524130|554180|549760|968209|524514|529741|537767|535989|536023|513213|442463|520058|558563|605141|968204|422817|422818|422819|410834|428331|483010|483011|483012|589206|968207|406136|419593|439954|407520|530060|531196|420132|242030|22402030|2223000000000007',
        meeza:
          '507803[0-6][0-9]|507808[3-9][0-9]|507809[0-9][0-9]|507810[0-2][0-9]|2223000000000007',
      };
    },
    errorMessage() {
      return (
        this.dateError ||
        this.cardError ||
        this.cvvError ||
        this.FirstNameError ||
        // this.LastNameError ||
        ''
      );
    },
  },
  mounted() {},

  methods: {
    ...mapActions([
      'createToken',
      'closeModal',
      'errorNotify',
      'createTokenShop',
    ]),
    validateFirstName(name) {
      name = name.trim();
      // Check if the name is empty
      if (name === '') {
        this.FirstNameError = this.$t(
          '_web_pay_fort_cardholder-required',
          'Card holder name is required field'
        );
      }
      // Check if the name contains only letters and spaces
      else if (!/^[a-zA-Z\s\u0600-\u06FF]+$/.test(name)) {
        this.FirstNameError = this.$t(
          '_web_pay_fort_cardholder-regular',
          'Card holder name can`t contain numbers or special characters'
        );
      }
      // Check if the name length is within an acceptable range
      else if (name.length <= 2 || name.length >= 50) {
        this.FirstNameError = this.$t(
          '_web_pay_fort_ardholder-long',
          'Card holder name must be between 2 and 50 characters'
        );
      }
      // If all checks pass, return true
      else {
        return (this.FirstNameError = '');
      }
    },

    handleInput(event) {
      event.target.id === 'card_number'
        ? (this.cardNumber = event.target.value.replace(/\D/g, ''))
        : event.target.id === 'card_security_code'
        ? (this.cardSecurityCode = event.target.value.replace(/\D/g, ''))
        : event.target.id === 'expiry_year'
        ? ((this.expiryYear = event.target.value.replace(/\D/g, '')),
          this.expiryYear.length === 0 &&
            this.$nextTick(() => this.$refs.expiryMonth.focus()))
        : event.target.id === 'expiry_month'
        ? ((this.expiryMonth = event.target.value.replace(/\D/g, '')),
          this.expiryMonth.length === 2 &&
            this.$nextTick(() => this.$refs.expiryYear.focus()))
        : null;
    },

    tokenization() {
      Promise.all([
        this.validateFirstName(this.cardFirstName),
        this.validateCardExpiry(this.expiryMonth, this.expiryYear),
        this.validateCard(this.cardNumber),
        this.validateCVV(this.cardSecurityCode, this.cardType),
        // this.validateLastName(),
      ])
        .then(() => {
          if (this.cardValidity && !this.errorMessage) {
            this.$emit('paymentProcessing');
            return !this.isShop
              ? this.createToken({
                  subscriptionId: this.subscription,
                  coupon: this.coupon,
                })
              : this.createTokenShop({
                  orderId: this.order,
                  coupon: this.coupon,
                });
          } else {
            throw new Error('card validation failed');
          }
        })
        .then(res => {
          this.accessCode = res.data.access_code;
          this.language = res.data.language;
          this.merchantIdentifier = res.data.merchant_identifier;
          this.merchantReference = res.data.merchant_reference;
          this.returnUrl = res.data.return_url;
          this.serviceCommand = res.data.service_command;
          this.signature = res.data.signature;
        })
        .then(() => {
          window.document.getElementById('submit2').click();
        })
        .catch(error => {
          if (this.cardValidity && !this.errorMessage) {
            this.closeModal(), this.$emit('paymentNotProcessing');
            this.errorNotify({
              message: error.message,
              inModal: true,
              yesText: this.$t('_web_form_error_confirm-yes', 'OK'),
            });
          }
        });
    },

    validateCard(card_number) {
      let card_type = '';
      let card_validity = true;
      this.cardValidity = card_validity;
      let message = '';
      this.cardError = message;
      let card_length = 0;
      if (card_number) {
        card_number = card_number.replace(/ /g, '').replace(/-/g, '');
        // Visa
        let visa_regex = new RegExp('^4[0-9]{0,15}$');
        // MasterCard
        let mastercard_regex = new RegExp('^5$|^5[0-5][0-9]{0,16}$');
        // American Express
        let amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$');
        //mada
        let mada_regex = new RegExp('^' + this.bins.mada);
        //meeza
        let meeza_regex = new RegExp(this.bins.meeza, 'gm');
        if (card_number.match(mada_regex)) {
          card_type = 'mada';
          this.cardType = card_type;
          card_length = 16;
        } else if (card_number.match(meeza_regex)) {
          card_type = 'meeza';
          this.cardType = card_type;
          card_length = 19;
        } else if (card_number.match(visa_regex)) {
          card_type = 'visa';
          this.cardType = card_type;
          card_length = 16;
        } else if (card_number.match(mastercard_regex)) {
          card_type = 'mastercard';
          this.cardType = card_type;
          card_length = 16;
        } else if (card_number.match(amex_regex)) {
          card_type = 'amex';
          this.cardType = card_type;
          card_length = 15;
        } else {
          card_validity = false;
          this.cardValidity = card_validity;

          message = this.apsPaymentErrors.invalid_card;
          this.cardError = message;
        }
        if (card_number.length < 15) {
          card_validity = false;
          this.cardValidity = card_validity;
          message = this.apsPaymentErrors.invalid_card_length;
          this.cardError = message;
        } else {
          let cardValidByAlgorithm = this.validateCardNumber(card_number);
          if (!cardValidByAlgorithm) {
            card_validity = false;
            this.cardValidity = card_validity;
            message = this.apsPaymentErrors.invalid_card;
            this.cardError = message;
          }
        }
      } else {
        message = this.apsPaymentErrors.card_empty;
        this.cardError = message;
        card_validity = false;
        this.cardValidity = card_validity;
      }
      return {
        card_type,
        validity: card_validity,
        msg: message,
        card_length,
      };
    },
    validateCardNumber(card_number) {
      //Check if the number contains only numeric value
      //and is of between 13 to 19 digits
      const regex = new RegExp('^[0-9]{13,19}$');
      if (!regex.test(card_number)) {
        return false;
      }
      return this.validateCardNumberByAlgorithm(card_number);
    },
    validateCardNumberByAlgorithm(card_number) {
      let checksum = 0; // running checksum total
      let j = 1; // takes value of 1 or 2
      // Process each digit one by one starting from the last
      for (let i = card_number.length - 1; i >= 0; i--) {
        let calc = 0;
        // Extract the next digit and multiply by 1 or 2 on alternative digits.
        calc = Number(card_number.charAt(i)) * j;
        // If the result is in two digits add 1 to the checksum total
        if (calc > 9) {
          checksum = checksum + 1;
          calc = calc - 10;
        }
        // Add the units element to the checksum total
        checksum = checksum + calc;
        // Switch the value of j
        if (j === 1) {
          j = 2;
        } else {
          j = 1;
        }
      }
      //Check if it is divisible by 10 or not.
      return checksum % 10 === 0;
    },
    validateCardExpiry(card_expiry_month, card_expiry_year) {
      let validity = true;
      let message = '';
      this.expValidity = validity;
      this.dateError = message;
      if (card_expiry_month === '' || !card_expiry_month) {
        validity = false;
        message = this.apsPaymentErrors.empty_expiry_date;
        this.expValidity = validity;
        this.dateError = message;
      } else if (card_expiry_year === '' || !card_expiry_year) {
        validity = false;
        message = this.apsPaymentErrors.empty_expiry_date;
        this.expValidity = validity;
        this.dateError = message;
      } else if (
        parseInt(card_expiry_month) <= 0 ||
        parseInt(card_expiry_month) > 12
      ) {
        validity = false;
        message = this.apsPaymentErrors.invalid_expiry_month;
        this.expValidity = validity;
        this.dateError = message;
      } else {
        let cur_date, exp_date;
        card_expiry_month = ('0' + parseInt(card_expiry_month - 1)).slice(-2);
        cur_date = new Date();
        exp_date = new Date(
          parseInt('20' + card_expiry_year),
          card_expiry_month,
          30
        );
        if (exp_date.getTime() < cur_date.getTime()) {
          message = this.apsPaymentErrors.invalid_expiry_date;
          validity = false;
          this.expValidity = validity;
          this.dateError = message;
        }
      }
      return {
        validity,
        msg: message,
      };
    },
    validateCVV(card_cvv, card_type) {
      if (card_cvv.length === 0) {
        this.cvvError = this.apsPaymentErrors.empty_card_cvv;
        this.cvvValidity = false;
        return;
      }
      let validity = false;
      let message = this.apsPaymentErrors.invalid_card_cvv;
      this.cvvValidity = validity;
      this.cvvError = message;

      if (card_cvv.length > 0) {
        card_cvv = card_cvv.trim();
        // if (!card_type.length || card_type.length === 0) {
        if (card_cvv.length === 3 && card_cvv !== '000') {
          validity = true;
          message = '';
          this.cvvValidity = validity;
          this.cvvError = message;
        } else if (
          card_cvv.length === 4 &&
          card_type === 'amex' &&
          card_cvv !== '0000'
        ) {
          validity = true;
          message = '';
          this.cvvValidity = validity;
          this.cvvError = message;
        }
        // }
      }
      return {
        validity,
        msg: message,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-container {
  max-width: 600px;
  margin: 0 auto;
}

.payment-header {
  text-align: center;
}

.payment-frame-container {
  margin-bottom: 20px;
}

.payment-form {
  display: grid;
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 5px;
  font-weight: 800;
}

.btn {
  background-color: #4caf50;
  color: white;
  padding: 10px;
  border: none;
  cursor: pointer;
}
.cvv-date {
  display: flex;
  gap: 10px;
  max-width: 100%;
}
.cvv-input-field {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.input-cvv {
  background-color: #18181f;
  border: none;
  padding: 10px;
  min-height: 2.5rem;
  border-radius: 5px;
  color: white;
  width: 100%;
}

.btn:hover {
  background-color: #45a049;
}

.card-payfort {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  padding: 16px 8px;
  border-radius: 16px;
  background: #242938;

  color: white;
  text-decoration: none;
  font-weight: bold;
  .input-form {
    font-weight: normal;
  }
}

.remember-me {
  display: flex;
  gap: 10px;
  label {
    font-size: 12px;
    font-style: normal;
    font-weight: 500 !important;
    margin-bottom: 0px !important;
  }
}

.expDate {
  display: flex;
  // max-width: fit-content;
  flex-basis: 30%;
}
.card-logo-payment-wrapper {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.slash-date {
  display: flex;
  justify-content: center;
  align-items: center;
}
.exp-date-field {
  border: none;
  min-height: 2.5rem;
  border-radius: 0px;
  padding-bottom: unset !important;
  padding-top: unset !important;
  @include auto-rtl(padding-right, unset !important);

  justify-content: center !important ;
  align-items: center !important;
  text-align: center !important;
  &::placeholder {
    text-align: left !important;
  }
}
.exp-date-field-devider {
  @include auto-rtl(padding-left, 5px !important);

  background-color: #18181f;
  border: none;
  min-height: 2.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #636363;
}
.month-class {
  width: 35px;
  @include auto-rtl(padding-left, 10px !important);

  @include auto-rtl(border-top-left-radius, 5px !important);
  @include auto-rtl(border-bottom-left-radius, 5px !important);
}
.year-class {
  width: 100px;
  @include auto-rtl(text-align, left !important);
  @include auto-rtl(align-items, left !important);
  @include auto-rtl(justify-content, left !important);

  @include auto-rtl(border-top-right-radius, 5px !important);
  @include auto-rtl(border-bottom-right-radius, 5px !important);
  &::placeholder {
    @include auto-rtl(text-align, left !important);
  }
}

.name-container {
  display: flex;
  gap: 10px;
  max-width: 400px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  .name-input {
    display: flex;
    width: 100%;
    flex-direction: column;
    @media (max-width: 445px) {
      min-width: 100%;
    }
  }
}
.error-message {
  color: red;
}
.form-group {
  margin-bottom: 8px;
}
.submit-hiden {
  height: 1px;
  width: 1px;
  display: none;
}
.error-input {
  border: 1px solid red;
}
.error-input-devider {
  border-top: 1px solid red;
  border-bottom: 1px solid red;
}
.payfort-save-card {
  font-family: Alexandria;
}
.error-input-month {
  border-top: 1px solid red;
  border-bottom: 1px solid red;
  @include auto-rtl(border-left, 1px solid red);
}
.error-input-year {
  border-top: 1px solid red;
  border-bottom: 1px solid red;
  @include auto-rtl(border-right, 1px solid red);
}
.font-Alexsandria {
  font-family: Alexandria !important;
  ::placeholder {
    font-family: Alexandria !important;
  }
}
</style>
